(() => {
  function init() {
    const root = document.querySelector('.pc-product');
    const form = root?.querySelector('#pc-product-form');
    if (!form || form.dataset.pcBound) return;
    form.dataset.pcBound = 'true';
    const quantity = form.querySelector('[name="quantity"]');
    const choices = [...form.querySelectorAll('[data-pc-pack]')];
    const summary = form.querySelector('[data-pc-summary]');
    function sync() {
      const selected = choices.find(input => input.checked);
      if (!selected) return;
      quantity.value = selected.value;
      quantity.setAttribute('value', selected.value);
      quantity.dispatchEvent(new Event('input', {bubbles:true}));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
      const q=Number(selected.value);
      summary.textContent=`${q} ${q===1?'caja':'cajas'} · ${q*30} parches · $${selected.dataset.total}`;
    }
    choices.forEach(input => input.addEventListener('change',sync));
    sync();
    // Releasit retains its last modal selection across openings. Select its real
    // quantity-offer control after opening, so the app recalculates its own total.
    let openObserver, openTimeout;
    document.addEventListener('click', event => {
      if (!event.target.closest('#_rsi-buy-now-button')) return;
      openObserver?.disconnect(); clearTimeout(openTimeout);
      const wanted=choices.find(input=>input.checked)?.value || '3';
      let applied=false;
      function selectNativeOffer(){
        const modal=document.getElementById('_rsi-cod-form-modal-form');
        if(!modal || !modal.getClientRects().length || applied)return;
        const nativeOffer=[...modal.querySelectorAll('._rsi-quantity-offers-offer-container')].find(el=>el.querySelector('._rsi-quantity-offers-title')?.textContent.trim().startsWith(wanted+' caja'));
        if(!nativeOffer)return;
        applied=true;openObserver?.disconnect();clearTimeout(openTimeout);
        if(!nativeOffer.classList.contains('_rsi-quantity-offers-selected'))nativeOffer.querySelector('._rsi-quantity-offers-offer')?.click();
      }
      openObserver=new MutationObserver(()=>requestAnimationFrame(selectNativeOffer));
      openObserver.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
      setTimeout(selectNativeOffer,100);
      openTimeout=setTimeout(()=>openObserver?.disconnect(),5000);
    },true);
    function polish() {
      const buttons=document.querySelectorAll('.pc-product #_rsi-buy-now-button, #_rsi-buy-now-button-floating #_rsi-buy-now-button');
      buttons.forEach(button=>{
      const styles={background:'#008b9a',color:'#ffffff','border-radius':'12px',border:'0px',width:'100%','min-height':'60px','font-size':'18px'};
      Object.entries(styles).forEach(([key,value])=>{if(button.style.getPropertyValue(key)!==value)button.style.setProperty(key,value,'important');});
      if(!button.dataset.pcAccessible){
        button.dataset.pcAccessible='true';button.setAttribute('role','button');button.tabIndex=0;
        button.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();button.click();}});
      }
      const label=button.querySelector('span');
      const text=root.querySelector('#pc-ofertas').dataset.buyLabel;
      if(label&&label.textContent!==text)label.textContent=text;
      });
    }
    polish();
    new MutationObserver(polish).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-pc-to-offers]');
    if(!link)return;
    const offers=document.getElementById('pc-ofertas');
    if(!offers)return;
    event.preventDefault();offers.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});offers.focus({preventScroll:true});
  });
})();
